import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Home from "./components/Pages/Home";
import "../src/assets/style.scss";
import Layout from "./components/Layout";
import AboutUs from "./components/Pages/AboutUs";
import ContactUs from "./components/Pages/ContactUs";
import Services from "./components/Pages/Services";
import ServicesDetail from "./components/Pages/ServicesDetail";
import PrivacyPolocy from "./components/Pages/PrivacyPolicy";
import Terms from "./components/Pages/Terms";
import DataDeletion from "./components/Pages/DataDeletion";

function ScrollHandler() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location.pathname]);

  return null;
}

function App() {
  

  return (
    <div className="App">
      <Router>
        <ScrollHandler />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolocy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:title" element={<ServicesDetail />} />
            <Route path="/data-deletion" element={<DataDeletion />} />
          </Route>
        </Routes>
      </Router>
  
    </div>
  );
}

export default App;
